import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/constants';

import { UserUpdateService } from '@/features/user-management/user-management-update/services';
import { IUserUpdate } from '../interfaces';

export const useUserDetailsQuery = (id: string) => {
  return useQuery({
    queryKey: QUERY_KEYS.userManagement.getUserDetails(id),
    queryFn: () => {
      return UserUpdateService.getUserDetails(id);
    },
  });
};

export const useUserUpdateMutation = (id: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: IUserUpdate) => {
      return UserUpdateService.updateUser(id, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.userManagement.getUserDetails(id) });
    },
  });
};
